exports.list = {
    path: '/kabupaten_kota',
    name: 'kabupaten_kota_list', 
      meta: {
        authRequired: true,
      },
    component: () => import("@/views/main/kabupaten_kota/List.vue"),
}
exports.show = {
    path: '/kabupaten_kota/show/:id',
    name: 'kabupaten_kota_show', 
        meta: {
            authRequired: true,
        },
    component: () => import("@/views/main/kabupaten_kota/Show.vue"),
}